import React from "react";
import { Col, Divider, Row, Typography } from "antd";

import ContentSection from "./ContentSection";
import { RulesDivisionsStyled } from "./style";
import { LeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const titlePointBonus = {
  stt: "A",
  name: "Point Bonus",
  subText:
    "Points are awarded based on user rank, with higher-ranked users receiving greater returns, incentivizing them to aim for higher ranks.",
};

const titleNftReward = {
  stt: "B",
  name: "NFT Reward",
  subText:
    "Users receive specific NFTs upon reaching certain ranks, adding an element of rarity and collectibility.",
};

const titleRebateBonus = {
  stt: "C",
  name: "Rebate Bonus",
  subText:
    "Rebate returns are provided based on the amount bet, with higher ranks receiving greater rebates, encouraging long-term participation.",
};

const RulesDivisions = ({ data, onClose }) => {
  return (
    <RulesDivisionsStyled>
      <Row justify={"space-between"} align="middle">
        <Col>
          <LeftOutlined
            onClick={onClose}
          />
        </Col>
        <Col>
          <Title level={1} style={{ color: "#156df2", margin: 0 }}>
            RULES
          </Title>
        </Col>
      </Row>
      <Divider style={{ border: '2px solid #156df2', margin: "16px 0", width: 2, borderRadius: 10 }} />
      <Title level={3} style={{ color: "#156df2" }}>
        BONUS REWARD
      </Title>
      <div className="scroll-content">
        <ContentSection title={titlePointBonus} data={data?.pointBonus} type="pointBonus" />
        <ContentSection title={titleNftReward} data={data?.nftReward} type="nftReward" />
        <ContentSection
          title={titleRebateBonus}
          data={data?.rebateRate}
          type="rebateBonus"
        />
      </div>
    </RulesDivisionsStyled>
  );
};

export default RulesDivisions;
